module.exports = __webpack_public_path__ + "1_0_59/img/share_white.7a34716a.svg";